import { styled } from 'styled-components';
import { slideAnimationStyle } from '../../styles/global.styles';
import { SIDEBAR_WIDTH } from '../SideNavigation/SideNav.styles';
import { HEADER_HEIGHT } from '../Header/Header.styles';

const FILTER_SECTION_HEIGHT = '100px';

export const StyledLayout = styled.div`
  height: 100vh;
  ${({ $withFilters }) =>
    $withFilters && `padding-top: ${FILTER_SECTION_HEIGHT}`};
  background-color: ${({ theme }) => theme.colours.canvas.primary.main};

  .core {
    z-index: 90;
    display: flex;
    ${({ $withFilters }) =>
      $withFilters && `height: calc(100vh - ${FILTER_SECTION_HEIGHT})`};
  }

  .cover {
    z-index: 102;
    position: absolute;
    height: 100vh;
    width: 100vw;
    background-color: ${({ theme }) => theme.colours.canvas.primary.main};
    left: ${SIDEBAR_WIDTH};
    top: ${HEADER_HEIGHT};
    padding: ${({ theme }) => theme.sizing.xlarge};
  }
`;
StyledLayout.displayName = 'StyledLayout';

export const BasicPage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
BasicPage.displayName = 'BasicPage';

export const FixedAside = styled.aside`
  position: relative;
  height: 100%;
  padding: ${({ theme }) => `${theme.sizing.small} 0 0 0`};
  overflow-y: auto;
  box-shadow: none;
  width: 100%;
  scrollbar-gutter: stable;
  display: ${({ $display }) => $display || 'block'};
  z-index: 2;

  ${({ theme }) => theme.mqFrom('md')} {
    width: ${({ $width }) => $width || 'inherit'};
    position: fixed;
    padding: ${({ theme, $padding }) =>
      $padding || `${theme.sizing.small} 0 6.9rem 0`};
    padding-top: ${({ theme, $paddingTopMD }) =>
      $paddingTopMD || theme.sizing.small};
    margin: ${({ theme }) => `-${theme.sizing.small} 0 0 0`};
    display: block;
    height: 100vh;
  }
`;
FixedAside.displayName = 'FixedAside';

export const FixedAsideContent = styled.div`
  position: relative;
  width: ${({ $width }) => $width || '100%'};
  margin: ${({ $margin }) => $margin || '0'};

  ${({ theme }) => theme.mqFrom('md')} {
    margin: ${({ $marginMd }) => $marginMd || '0'};
  }

  > div:first-child {
    margin: -0.5rem 0 0 0;
    padding: 0;
    width: 100%;

    ${({ theme }) => theme.mqFrom('md')} {
      margin: ${({ $marginMdChild }) =>
        $marginMdChild || '-0.5rem -0.5rem auto auto'};
      width: ${({ $widthMd }) => $widthMd || 'calc(100% + 0.5rem)'};
    }
  }
`;

export const Main = styled.main`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.colours.canvas.primary.main};
  overflow: auto;
`;
Main.displayName = 'Main';

// (RH) sidebar layout
// based on immediate two child <div>
// sidebar width defaults to 200px
export const SidebarRightLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ $gap }) => $gap || '1rem'};
  width: 100%;
  padding: ${({ $padding }) => $padding || '0 0.5rem'};

  > :last-child {
    flex-basis: ${({ $sidebarWidth }) => $sidebarWidth || '200px'};
    transition: ${`flex-basis 500ms ${slideAnimationStyle}`};
    flex-grow: ${({ $closed }) => $closed || 1};
  }

  > :first-child {
    flex-basis: 0;
    flex-grow: 999;
    min-inline-size: ${({ $inlineSize }) => $inlineSize || '60%'};
  }
`;
SidebarRightLayout.displayName = 'SidebarRightLayout';

/*
This is removing the standard padding from Main in the layout so the grid component page can be used instead
Once the grid is implemented universally it can be dropped
 */
export const BasicPageNoPadding = styled.div`
  position: absolute;
  top: ${({ $top }) => $top || '98px'}; /* visible height of the top bar */
  left: 0;
  ${({ theme }) => theme.mqFrom('md')} {
    left: ${({ $left }) =>
      $left || `${SIDEBAR_WIDTH}`}; /* visible width of the sidebar */
  }
  margin: 0;
  padding: 0;
  width: 100%;
  ${({ theme }) => theme.mqFrom('md')} {
    width: calc(100% - ${SIDEBAR_WIDTH});
  }
  z-index: 0;
`;
BasicPageNoPadding.displayName = 'BasicPageNoPadding';

/*
Div holding the Grid used to override default margin-top so layout is correct
 */
export const KitbagPageGridHolder = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;

  /*the <Grid> component */
  & > div:first-child {
    margin-top: 0;
    margin-bottom: ${({ theme }) => `${theme.sizing.regular}`};
    flex-direction: column-reverse;

    ${({ theme }) => theme.mqFrom('md')} {
      flex-direction: row;
    }
  }
`;
KitbagPageGridHolder.displayName = 'KitbagPageGridHolder';

export const GridBackground = styled.div`
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  height: 100%;
`;
GridBackground.displayName = 'GridBackground';

export const CardBodyWrapper = styled.div`
  height: 100%;
  min-height: calc(100vh - 224px);

  > div {
    height: 100%;
  }
`;
CardBodyWrapper.displayName = 'CardBodyWrapper';
